import { requestFunnel } from '@/application/api';
import store from '@/ui/store';
import i18n from '@/ui/i18n';

const country = i18n.locale;
const currentUserSubject = () => store.state.currentUser;

const login = async (email, password) => {
  const { data: { user, token, checkIn, nextMonthlyPayment, nextMonthlyPaymentType } } = await requestFunnel.post('auth/login', { email, password });
  user.checkIn = checkIn;
  user.nextMonthlyPayment = nextMonthlyPayment;
  user.nextMonthlyPaymentType = nextMonthlyPaymentType;
  user.country = country;
  store.dispatch('setCurrentUser', { user, token, date: new Date() });
  return currentUserSubject();
};

const restorePassword = async email => requestFunnel.post('auth/restore-password', { email });

const logout = () => {
  store.dispatch('clearCurrentUser');
  store.dispatch('clearPaymentData');
};

const authHeader = () => {
  const { user, token } = store.state.currentUser || {};

  if (user && token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const restorePasswordApply = async (email, token) => {
  await requestFunnel.get(`auth/restore-password-apply?token=${token}&email=${email}`);
};

const restoreEmail = async (idNumber, newEmail) => {
  await requestFunnel.get(`auth/restore-email?idNumber=${idNumber}&newEmail=${newEmail}`);
};

const restoreEmailApply = async (token, idNumber, newEmail) => {
  await requestFunnel.get(`auth/restore-email-apply?token=${token}&idNumber=${idNumber}&newEmail=${newEmail}`);
};

const rejectEmailChange = async (idNumber, newEmail) => {
  await requestFunnel.get(`auth/restore-email-reject?idNumber=${idNumber}&newEmail=${newEmail}`);
};

const changeDetails = async ({ currentPassword, password, confirmation, email, phone, homePhone, codebtorEmail, codebtorPhone, codebtorHomePhone }) => {
  await requestFunnel.post('auth/change-details', { currentPassword, password, confirmation, email, phone, homePhone, codebtorEmail, codebtorPhone, codebtorHomePhone }, { headers: authHeader() });
};

export const authenticationService = {
  login,
  logout,
  authHeader,
  currentUser: currentUserSubject(),
  restorePassword,
  restorePasswordApply,
  changeDetails,
  restoreEmail,
  restoreEmailApply,
  rejectEmailChange
};
